import template from './coderreviewed.html';
import controller from './coderreviewed.controller';
import './coderreviewed.styl';

let coderreviewedComponent = {
  restrict: 'E',
  bindings: {},
  template,
  controller,
  controllerAs: 'vm'
};

export default coderreviewedComponent;



// WEBPACK FOOTER //
// ./client/app/common/reports/coderreviewed/coderreviewed.component.js